module.exports = __webpack_public_path__ + "static/img/bg_task.c0bff02.png";


//////////////////
// WEBPACK FOOTER
// ../vue-common-laboratory/src/assets/images/bg_task.png
// module id = W60A
// module chunks = 115